/**
 * Created by minghua.li on 2021/7/7.
 */
// 公共方法集合
import md5 from 'js-md5';
const baseUtils = {};

//图片懒加载
/* <img class="lazy-img" data-src="https://www.png"/>  图片懒加载
 * <img class="lazy-img lazy-bg" data-src="https://www.png">  背景懒加载
 *  */
baseUtils.queryDom = function(selector) {
    return Array.from(document.querySelectorAll(selector));
}
baseUtils.imgLazyLoad = function(el) {
    let io = new IntersectionObserver(
        function (entries) {
            // 如果在可视区域
            if (entries[0].intersectionRatio > 0){
                if(entries[0].target.className.indexOf('lazy-bg')>-1){
                    entries[0].target.style.backgroundImage = "url("+entries[0].target.getAttribute('data-src')+")";
                }else{
                    entries[0].target.src = entries[0].target.getAttribute('data-src');
                }
                io.disconnect();
            }
        });
    io.observe(el)
}
baseUtils.doLazyLoading = function() {
    setTimeout(function() {
        baseUtils.queryDom('.lazy-img').forEach(function (item) {
            baseUtils.imgLazyLoad(item);
        });
    },300)
}
//生成接口签名
baseUtils.makeSign = function (data,secret) {
    let keys = [],stringArray = [];
    for (let key in data) {
        keys.push(key);
    }
    keys.sort();
    for (let i = 0; i < keys.length; i++) {
        if (typeof data[keys[i]] == 'object') {
            stringArray[i] = keys[i] + "=" + JSON.stringify(data[keys[i]]);
        } else {
            stringArray[i] = keys[i] + "=" + data[keys[i]];
        }
    }
    let stringA = stringArray.join("&");
    let resSign = md5(md5(stringA)+(secret||staticData.website.site_info.site_sign_secret));
    return resSign;
}

baseUtils.toKB = function(Byte) {  //MB转KB
    if (Byte !== 0) {
        return (Byte / 1024).toFixed(0);
    } else {
        return 0;
    }
}
/** 流量显示规范 传入流量单位为MB
 * 1.单位的显示规范=>流量值小于1000MB，单位显示MB；流量值大于等于1000MB，单位显示GB 如：999MB=999MB,1000MB=0.97GB,1001MB=0.97GB
 * 2.小数点的显示规范=>单位MB后隐藏（非四舍五入）小数点后位数；单位GB后显示至多两位小数点后位数。如：666.66MB=666MB,1000MB=0.97GB,1925.12MB=1.88GB
 * 3.小数点后末位的0的显示规范=>小数点后末位为0时隐藏0。如：1536MB=1.5GB,1024GB=1GB,1024.88GB=1GB
 **/
baseUtils.trafficRules = function(mb) {
    let tempValue = '';
    if(mb && mb<1000){
        let tempVal = mb.toFixed(2).split('.');
        if(tempVal[1]=='00'){
            tempValue = tempVal[0]+"MB";
        }else{
            tempValue = mb.toFixed(2) +"MB";
        }

    }else if(mb && mb>=1000){
        let tempVal = (mb/1024).toFixed(2).split('.');
        if(tempVal[1]=='00'){
            tempValue = tempVal[0]+"GB";
        }else{
            tempValue = (mb/1024).toFixed(2) +"GB";
        }
    }
    return tempValue;
};
// 币种字符串
baseUtils.currencyStr = function(str){
    if(!str) return '';
    let currency = "";
    let currObj = {
        "USD":"$",
        "CNY":"￥",
        "GBP":"￡",//英镑
        "EUR":"€",//欧元
        "SGD":"S$",//新加坡
        "MYR":"M$",//马来西亚
        "TRY":"₺‌‌",//土耳其
    }
    currency = currObj[str]||"$";
    return currency;
}

baseUtils.sub = function Subtr(arg1,arg2){
    var r1,r2,m,n;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2));
    n=(r1>=r2)?r1:r2;
    return ((arg1*m-arg2*m)/m).toFixed(n);
}


export default baseUtils;
